import * as _ from 'lodash'
import RangeMap from './range-map.vue'
import toll from '../../services/toll'

export default {
  data() {
    return {
      selected: undefined,
      entries: undefined,
      loading: undefined,
      mapState: undefined,
      bkEntries: undefined,
      search: '',
      pedagios: undefined
    }
  },

  watch:{
    selected: function(val){
      this.getTolls();
    }
  },

  created: function(){

  },

  computed: {
    entriesKey() {
      if(this.entries)
        return _.keys(this.entries);

        return undefined;
    },
    // stateName() {
      // return _.uniq(this.entriesKey.map(({ state }) => state));
    // }
    // stateName(){
    //   if(this.mapState)
    //     return this.mapState[this.selected].name;
    //
    //   return this.selected;
    // },
    // percent(){
    //   if(this.mapState)
    //     return this.mapState[this.selected].percent;
    //
    //   return "";
    // }
  },

  mounted() {
    this.getListTolls();
    // 
  },

  methods: {
    getListTolls() {
      this.loading = toll.getListTolls().then(res => {
        // 
        // this.bkEntries = res;

        this.pedagios = {};
        for(var i=0; i<res.length; i++) {
          if(!this.pedagios[res[i].state]) {
            this.pedagios[res[i].state] = {};
          }
          if(!this.pedagios[res[i].state][res[i].associateFinancialId]) {
            this.pedagios[res[i].state][res[i].associateFinancialId] = [];
          }
          this.pedagios[res[i].state][res[i].associateFinancialId].push(res[i]);

        }
        // 
        //
        this.entries = _.groupBy(res, 'associateFinancialId');
        this.mapState = _.groupBy(res, 'state');
        this.entriesKey = '';
        this.search = '';
      }).catch(err => {
        
      });
    },

    getTolls(){
      this.loading = toll.getTollsByState(this.selected)
        .then(res => {
            this.bkEntries = res;
            this.entries = _.groupBy(res, 'associateFinancialId');
            this.search = '';
            this.pedagios = '';
        })
        .catch(err => {

        });

    },
    getImg(id){
      return `static/highway_managers/${id}.png`;
    },
    filter: _.debounce(function(){
      if(this.search == ''){
        this.entries = _.groupBy(this.bkEntries, 'state');
        // this.entries = _.groupBy(this.bkEntries, 'associateFinancialId');
        return;
      }

      let s = this.search.toUpperCase();
      this.entries = _.chain(this.bkEntries).filter(function(o){
        return o.associate.toUpperCase().indexOf(s) >= 0 || o.city.toUpperCase().indexOf(s) >= 0
        || o.tipo.toUpperCase().indexOf(s) >= 0 || o.roadCode.toUpperCase().indexOf(s) >= 0
        || o.km.toUpperCase().indexOf(s) >= 0
      }).groupBy('state').value();
      // }).groupBy('associateFinancialId').value();
    }, 400)
  },

  components: {
    RangeMap
  }
}



// WEBPACK FOOTER //
// ./src/pages/external/range.js